export default "__VITE_ASSET__DSql4Inb__"